import { useState, useCallback, useEffect } from 'react';
import { HistoryHashType, PAGINATION_DEFAULT_ITEMS_PER_PAGE } from "../data/settings";
import {getCurrentCabinet, getHistoryHash, setHistoryHash as setHistoryHashFunc} from "../helpers/functions";
import { MainMetaType } from "../redux/Main/common";
import { MainRequestType} from "../redux/types";

interface UseHistoryProps {
    componentType: string;
    loadAction: (meta: MainMetaType) => any;
    dispatch: any;
}

export const useHistory = ({ componentType, loadAction, dispatch }: UseHistoryProps) => {
    const [historyHash, setHistoryHash] = useState<HistoryHashType>({ type: componentType });
    const [searchPhrase, setSearchPhrase] = useState<string>('');

    const updateHistoryHash = useCallback(() => {
        const browserHistoryHash = getHistoryHash();
        if (browserHistoryHash !== null && browserHistoryHash.type === componentType) {
            setHistoryHash(browserHistoryHash);
        }
    }, [componentType]);

    const loadItems = useCallback((request?: MainRequestType) => {

        const currentCabinet = getCurrentCabinet();

        const mainMeta: MainMetaType = {
            page: historyHash.page || 1,
            maxResults: historyHash.maxResults ? historyHash.maxResults : PAGINATION_DEFAULT_ITEMS_PER_PAGE,
            sortField: historyHash.sortField,
            sortDirection: historyHash.sortDirection,
            searchPhrase: historyHash.searchPhrase && historyHash.searchPhrase.length > 0 && historyHash.searchPhrase,
            request: request ?? null,
            tab: historyHash.tab ?? null,
            status: historyHash.status ?? null,
            cabinetUuid: (currentCabinet !== false && currentCabinet?.uuid) ? currentCabinet.uuid : null
        };

        dispatch(loadAction(mainMeta));
    }, [dispatch, historyHash, loadAction]);

    useEffect(() => {
        if (historyHash.searchPhrase !== undefined && historyHash.searchPhrase.length > 0 && searchPhrase !== historyHash.searchPhrase) {
            setSearchPhrase(historyHash.searchPhrase);
        }
        loadItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [historyHash, loadItems]);

    useEffect(() => {
        const hashChangeHandler = () => updateHistoryHash();
        window.addEventListener('hashchange', hashChangeHandler);
        updateHistoryHash();
        return () => window.removeEventListener('hashchange', hashChangeHandler);
    }, [updateHistoryHash]);

    const handleSearchClick = useCallback((value: string) => {
        setSearchPhrase(value);
        if (historyHash.searchPhrase !== value) {
            const newHash = { ...historyHash, searchPhrase: value };
            setHistoryHashFunc(newHash);
            setHistoryHash(newHash);
        }
    }, [historyHash]);

    return {
        historyHash,
        setHistoryHash,
        searchPhrase,
        setSearchPhrase,
        loadItems,
        handleSearchClick
    };
};